<template>
    <DnSlider
        class="base-slider"
        :controls-enabled="true"
    >
        <!-- Pass down whatever slots are given to this component-->
        <template
            v-for="name in Object.keys($slots)"
            v-slot:[name]="scope"
        >
            <slot
                :name="name"
                v-bind="scope || {}"
            />
        </template>

        <template v-slot:controlRight="{ scrollRight, isVisible }">
            <div
                role="button"
                title="Scroll right"
                class="slider__control-right"
                :disabled="!isVisible"
                @click="scrollRight"
            >
                <BaseIcon
                    icon="chevron-right"
                />
            </div>
        </template>

        <template v-slot:controlLeft="{ scrollLeft, isVisible }">
            <div
                role="button"
                title="Scroll left"
                class="slider__control-left"
                :data-disabled="!isVisible"
                @click="scrollLeft"
            >
                <BaseIcon
                    icon="chevron-left"
                />
            </div>
        </template>
    </DnSlider>
</template>

<script setup>
import DnSlider from '@digitalnatives/slider';
</script>

<style src="./BaseSlider.less" lang="less"></style>
